export function convertColorArrayToRgbString(colorArr) {
    return Array.isArray(colorArr)
        ? `rgb(${colorArr.map((v) => Math.round(v * 255)).join(',')})`
        : colorArr;
}
